import { faSync } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Stack, Tooltip } from "@mui/joy";
import { memo } from "react";
import { EntitiesSearch, ExportAsCsvButton } from "components/base";

interface DataRoomLogsToolbarProps {
  onSearchChange: (value: string) => void;
  searchValue: string;
  isLoading?: boolean;
  onFetchLogs: () => void;
  hasData: boolean;
  getLogs: () => string[][];
}

const getHeaders = () => ["Event date", "Performed by", "Description"];

const DataRoomLogsToolbar = memo<DataRoomLogsToolbarProps>(
  ({
    onSearchChange,
    searchValue,
    isLoading,
    onFetchLogs,
    hasData,
    getLogs,
  }) => {
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        rowGap={2}
        width="100%"
      >
        <Stack direction="row" sx={{ width: "280px" }}>
          <EntitiesSearch
            onChange={(event) => onSearchChange(event.target.value)}
            onClear={() => onSearchChange("")}
            placeholder="Search"
            value={searchValue}
          />
        </Stack>
        <Stack direction="row">
          <Tooltip title="Refresh the table">
            <IconButton
              disabled={isLoading}
              loading={isLoading}
              onClick={onFetchLogs}
            >
              <FontAwesomeIcon icon={faSync} />
            </IconButton>
          </Tooltip>
          {hasData ? (
            <ExportAsCsvButton
              fileName="data-room-logs.csv"
              getHeaders={getHeaders}
              getRows={getLogs}
            />
          ) : null}
        </Stack>
      </Stack>
    );
  }
);

export default DataRoomLogsToolbar;
